const EDUCATION_TYPE = [{
    value: 'BasicEducation', label: 'Educação Básica'
},
{
    value: 'HigherEducation', label: 'Educação superior'
}]

export default EDUCATION_TYPE